import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Container,
  Dropdown,
  Form,
  InputGroup,
  Row,
  Stack,
} from "react-bootstrap";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import DateRangePicker from "../../../common/CustomDateRangePicker";
import { Filter } from "lucide-react";
import AppointmentActionsDropdown from "../../../common/AppointmentActionsDropdown";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
import { HISTORIAN_ACTIONS } from "../../../common/EventConstant";
import {
  getHistorianCardSearch,
  getHistorianSimpleSearch,
} from "../../../services/HistorianAPI";
import { HistorianHeader } from "./actions/constants";
import HistorianActionDrawer from "./components/HistoriansActionDrawer";
import HistorianUploadRecord from "./components/HistoriansUploadRecord";
import HistorianAddNotes from "./components/HistoriansAddNotes";
import HistorianScheduleDate from "./components/HistorianScheduleDate";
import HistorianDataTable from "../../../common/HistorionDataTable";
import {
  CASE_STAGE_STATUS,
  HISTORIAN_SUMMARY_CODES,
  HISTORY_REPORT_STATUS,
  QME_APPOINTMENT_STATUS,
} from "../../../common/Constant";
import CustomPagination from "../../../common/Pagination";
import TableRowsPerPage from "../../../common/TableRowsPerPage";
import Loader from "../../../common/Loader";
import useAnimatedCounter from "../useAnimatedCounter";
import Snackbar from "../../../common/Snackbar";
import { useLocation, useNavigate } from "react-router-dom";
import {
  setIsDashboard,
  setNewCaseInFoID,
} from "../../../redux/slice/CaseHeaderSlice";

const HistorianDashboard = () => {
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [loading, setLoading] = useState<boolean>(false);

  const inputRef = useRef<HTMLInputElement | null>(null);
  const [searchQuery, setSearchQuery] = useState<string>("");

  // --- Inside your component ---
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  const [computedMinDate, setComputedMinDate] = useState<Date | undefined>();
  const [computedMaxDate, setComputedMaxDate] = useState<Date | undefined>();

  const [dateRange, setDateRange] = useState<
    [Date | undefined, Date | undefined]
  >([firstDayOfMonth, lastDayOfMonth]);

  const handleDateRangeChange = (newRange: [Date | null, Date | null]) => {
    const [start, end] = newRange;
    setDateRange([start ?? undefined, end ?? undefined]);
  };

  useEffect(() => {
    // 📅 Allow selection from 1 year before today to 1 year after today
    const min = new Date(today);
    min.setFullYear(today.getFullYear() - 1);

    const max = new Date(today);
    max.setFullYear(today.getFullYear() + 1);

    setComputedMinDate(min);
    setComputedMaxDate(max);
  }, []);

  // selected action from dropdown
  const [selectedAction, setSelectedAction] = useState<string | number>("");

  //state for historain data
  const [historionData, setHistorionData] = useState<any[]>([]);
  const [exporthistorionData, setexportHistorionData] = useState<any[]>([]);
  const [selectedCaseId, setSelectedCaseId] = useState<number | null>(null);
  const [activeFilter, setActiveFilter] = useState(
    HISTORIAN_SUMMARY_CODES.OVERDUE_TODAY,
  );
  const [activeCard, setActiveCard] = useState<string>("Overdue");
  const [activeSubCard, setActiveSubCard] = useState<string>("Today");
  const [activeListName, setActiveListName] = useState<string>(
    "Overdue List (Today)",
  );

  const [drawerTitle, setDrawerTitle] = useState("");
  const [showHistorianActionDrawer, setShowHistorianActionDrawer] =
    useState(false);

  const [pendingOverdueCount, setPendingOverdueCount] = useState<string>("");
  const [todayOverdueCount, setTodayOverdueCount] = useState<string>("");
  const [overdueCount, setOverdueCount] = useState<string>("");
  const [draftHistories, setDraftHistories] = useState<string>("");
    const [scheduledToday, setScheduledToday] = useState<string>("");
  const [scheduledThisWeek, setScheduledThisWeek] = useState<string>("");
  const [scheduledThisMonth, setScheduledThisMonth] = useState<string>("");
  const [totalHistoriesPending, setTotalHistoriesPending] =
    useState<string>("");
  const [totalHistoriesCompleted, setTotalHistoriesCompleted] =
    useState<string>("");
  const [totalAppointmentCancelled, setTotalAppointmentCancelled] =
    useState<string>("");
  const [notScheduled, setNotScheduled] = useState<string>("");
  const [notScheduledOverdue, setNotScheduledOverdue] = useState<string>("");
  const [awaitingResponse, setAwaitingResponse] = useState<string>("");
   const [allReportsResponse, setAllReportsResponse] = useState<string>("");

  const [totalRows, setTotalRows] = useState<any>("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(15);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [sortColumn, setSortColumn] = useState<string>("");
  const [sortOrder, setSortOrder] = useState<string>("DESC");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");

  const allowedFeatures = useSelector(
    (state: RootState) => state.featureAccess.allowedFeatures,
  );

  const getSelectedRowData = () => {
    if (!selectedCaseId) return null;
    return historionData.find(
      (row) => row.subjectQmeScheduleID === selectedCaseId,
    );
  };

  const selectedRowData = getSelectedRowData();


  const updatedHistorianHeader = useMemo(() => {
    if (activeListName === "Total Histories List (Completed)") {
      return HistorianHeader.map((col) =>
        col.key === "tatDays" ? { ...col, label: "TAT (in Days)" } : col,
      );
    }
    return HistorianHeader;
  }, [activeListName]);

  const allOptions = {
    schedule: {
      value: "Schedule Date",
      label: selectedRowData?.scheduledDate
        ? "Re-Schedule Date"
        : "Schedule Date",
    },
    records: {
      value: "Upload Records",
      label: "Upload History",
    },
    notes: {
      value: "Add Notes",
      label: "Add Notes",
    },
  };

  const optionFeatureMap: Record<string, string> = {
    "Schedule Date": HISTORIAN_ACTIONS.SCHEDULED_DATE,
    "Upload Records": HISTORIAN_ACTIONS.UPLOAD_RECORDS,

    "Add Notes": HISTORIAN_ACTIONS.ADD_NOTES,
  };

  const filteredActionOptions = useMemo(() => {
    let options = Object.values(allOptions).filter((option) =>
      allowedFeatures.has(optionFeatureMap[option.value]),
    );

    const status = selectedRowData?.historyStatus;

    const appointmentStatus = selectedRowData?.appointmentStatus;
    const date = selectedRowData?.scheduledDate;
    const isPendingOrNotScheduled =
      status === HISTORY_REPORT_STATUS.COMPLETED ||
      status === HISTORY_REPORT_STATUS.Completed_Delayed ||
      appointmentStatus === QME_APPOINTMENT_STATUS.CANCELLED ||
      appointmentStatus === QME_APPOINTMENT_STATUS.PATIENT_NO_SHOW ||
      appointmentStatus === QME_APPOINTMENT_STATUS.QME_NO_SHOW ||
      appointmentStatus === QME_APPOINTMENT_STATUS.INTERPRETER_NO_SHOW ||
      appointmentStatus === QME_APPOINTMENT_STATUS.COMPLETED ||
      activeListName == "Overdue List (Past Overdue)" ||
      activeListName == "Not Scheduled List (Overdue)";
    if (isPendingOrNotScheduled) {
      // Remove Schedule option if condition not met
      options = options.filter((opt) => opt.value !== "Schedule Date");
    }

    if (
      status === HISTORY_REPORT_STATUS.COMPLETED ||
      status === HISTORY_REPORT_STATUS.Completed_Delayed
    ) {
      options = options.filter((opt) => opt.value !== "Upload Records");
    }

    return options;
  }, [allowedFeatures, selectedRowData]);

  const handleActionChange = (value: string | number) => {
    setSelectedAction(value);

    if (value === "Upload Records") {
      setShowHistorianActionDrawer(true);
      setDrawerTitle("Records");
    } else if (value === "Add Notes") {
      setShowHistorianActionDrawer(true);
      setDrawerTitle("Add Notes");
    } else if (value === "Schedule Date") {
      setShowHistorianScheduleDate(true);
      setDrawerTitle("ScheduleDate");
    }
  };

  const toLocalISOString = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getSearchHistorianData = async (
    query: string = "",
    action: string = "",
    pageNo: number = 1,
    pageSize: number = itemsPerPage,
    key: string = sortColumn,
    direction: string = sortOrder,
  ) => {
    try {
      // Convert dateRange to ISO strings safely
      setLoading(true);

      const trimmedQuery = query?.trim();
      const [start, end] = dateRange;
      const payload = {
        searchString: trimmedQuery || "",
        startDate: start ? toLocalISOString(start) : "",
        endDate: end ? toLocalISOString(end) : "",
        actionTrigger: action,
        pageNo,
        pageSize,
        sortColumn: key,
        sortOrder: direction,
      };

      const response = await getHistorianSimpleSearch(payload);

      // Step 3: Set state with updated response
      setHistorionData(response);
      setTotalPages(response[0]?.totalPages || 1);
      setTotalRows(response[0]?.totalCount || null);
      setSelectedCaseId(null);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const latestSummaryRequestId = useRef(0);

  const getHistorianSummaryData = async (
    query: string = "",
    action: string = "",
  ) => {
    const requestId = ++latestSummaryRequestId.current;
    try {
      // Convert dateRange to ISO strings safely
      const trimmedQuery = query?.trim();
      const [start, end] = dateRange;
      const payload = {
        searchString: query || "",
        // startDate: start ? toLocalISOString(start) : "",
        // endDate: end ? toLocalISOString(end) : "",
        startDate: start ? toLocalISOString(start) : "",
        endDate: end ? toLocalISOString(end) : "",
        actionTrigger: action,
      };

      const response = await getHistorianCardSearch(payload);
      if (requestId !== latestSummaryRequestId.current) return;

      if (response) {
        setPendingOverdueCount(response?.pendingOverdueCount ?? "");
        setTodayOverdueCount(response?.todayOverdueCount ?? "");
        setOverdueCount(response?.overdueCount ?? "");
        setDraftHistories(response?.draftHistories ?? "");
        setScheduledThisWeek(response?.scheduledThisWeek ?? "");
        setScheduledThisMonth(response?.scheduledThisMonth ?? "");
        setScheduledToday(response?.scheduledToday ?? "");
        setTotalHistoriesPending(response?.totalHistoriesPending ?? "");
        setTotalHistoriesCompleted(response?.totalHistoriesCompleted ?? "");
        setTotalAppointmentCancelled(response?.totalApptCancelled ?? "");
        setNotScheduled(response?.notScheduled ?? "");
        setNotScheduledOverdue(response?.notScheduledOverDue ?? "");
        setAwaitingResponse(response?.awaitingResponse ?? "");
        setAllReportsResponse(response?.allHistorian ?? "");
        setSelectedCaseId(null);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const [start, end] = dateRange;

    if (start && end) {
      getSearchHistorianData(
        searchQuery,
        activeFilter,
        currentPage,
        itemsPerPage,
        sortColumn,
        sortOrder,
      );
    }
  }, [
    dateRange,
    searchQuery,
    currentPage,
    itemsPerPage,
    sortColumn,
    sortOrder,
  ]);

  useEffect(() => {
    const [start, end] = dateRange;

    if (start && end) {
      getHistorianSummaryData(searchQuery, activeFilter);
    }
  }, [dateRange, searchQuery]);

  const debounce = (func: Function, delay: number) => {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const handleInputChange = debounce((value: string) => {
    if (value.length >= 3 || value.length === 0) {
      setSearchQuery(value);
      setCurrentPage(1);
    }
  }, 300);

  const handleResetFilters = () => {
    if (inputRef.current) {
      inputRef.current.value = "";
    }

    setSearchQuery("");
  };

  useEffect(() => {
    if (!activeFilter) return;

    const [start, end] = dateRange;

    const filterQuery = searchQuery || "";

    // First get summary
    getHistorianSummaryData(filterQuery, activeFilter);

    // Then get search table
    getSearchHistorianData(
      filterQuery,
      activeFilter,
      1,
      itemsPerPage,
      sortColumn,
      sortOrder,
    );
  }, [activeFilter, dateRange]);

  const handleActionDrawer = () => {
    setShowHistorianActionDrawer(false);
  };

  const handlecloseActionDrawer = async (
    actionType?: "exception" | "normal" | "draft" | "final",
  ) => {
    setShowHistorianActionDrawer(false);

    // if (actionType === "exception") {
    //   handleCardClick(HISTORIAN_SUMMARY_CODES.AWAITING_RESPONSE);
    //   setActiveCard("Awaiting Response");
    //   setActiveSubCard("");
    //   setActiveListName("Awaiting Response List");
    // } else if (actionType === "draft") {
    //   handleCardClick(HISTORIAN_SUMMARY_CODES.DRAFT_HISTORIES);
    //   setActiveCard("Draft Histories");
    //   setActiveListName("Draft Histories List");
    //   setActiveSubCard("");
    // } else if (actionType === "final") {
    //   handleCardClick(HISTORIAN_SUMMARY_CODES.TOTAL_COMPLETED);
    //   setActiveCard("Total Histories");
    //   setActiveSubCard("TC");
    //   setActiveListName("Total Histories List (Completed)");
    // }

    getHistorianSummaryData(searchQuery, activeFilter);

    getSearchHistorianData(
      searchQuery,
      activeFilter,
      currentPage,
      itemsPerPage,
      sortColumn,
      sortOrder,
    );
  };

  const [showHistorianScheduleDate, setShowHistorianScheduleDate] =
    useState(false);

  const handlecloseScheduleDate = async (fromSave?: boolean) => {
    setShowHistorianScheduleDate(false);

    if (fromSave) {
      // setActiveCard("Total Histories");
      // handleCardClick(HISTORIAN_SUMMARY_CODES.TOTAL_PENDING);
      // setActiveSubCard("TP");
      // setActiveListName("Total Histories List (Pending)");

      getSearchHistorianData(
        searchQuery,
        activeFilter,
        currentPage,
        itemsPerPage,
        sortColumn,
        sortOrder,
      );

      getHistorianSummaryData(searchQuery, activeFilter);
    }
  };

  const getBase64FromUrl = async (url: string): Promise<string> => {
    const res = await fetch(url);
    const blob = await res.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (typeof reader.result === "string") {
          resolve(reader.result);
        } else {
          reject("Failed to convert blob to base64");
        }
      };
      reader.onerror = () => reject("Failed to read blob");
      reader.readAsDataURL(blob);
    });
  };
  const handleExportPDF = async () => {
    try {
      const selectedStatus = activeListName;
      const [startDate, endDate] = dateRange;

      // ---------- Date Label ----------
      const formatDate = (date: Date) =>
        date.toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        });

      let dateLabel = "";
      if (startDate && endDate && startDate.getTime() !== endDate.getTime()) {
        dateLabel = `${formatDate(startDate)} to ${formatDate(endDate)}`;
      } else {
        dateLabel = formatDate(startDate || new Date());
      }

      const title = `Appointments for ${selectedStatus} ${dateLabel}`;

      const logoBase64 = await getBase64FromUrl("/logo.png");

      // ---------- Headers ----------
      const headers: string[] = [
        "Sr. No",
        ...HistorianHeader.map((h: any) => h.label || h.name),
      ];

      // ---------- API ----------
      const trimmedQuery = searchQuery?.trim();
      const payload = {
        searchString: trimmedQuery,
        startDate: startDate ? toLocalISOString(startDate) : "",
        endDate: endDate ? toLocalISOString(endDate) : "",
        actionTrigger: activeFilter,
        pageNo: 1,
        pageSize: 100000,
        sortColumn: "",
        sortOrder: "DESC",
      };

      const response = await getHistorianSimpleSearch(payload);

      if (!Array.isArray(response) || response.length === 0) {
        alert("No data available for export");
        return;
      }

      // ---------- Table Data (IMPORTANT FIX) ----------
      const tableData: (string | number | null)[][] = response.map(
        (row: any, index: number) => {
          const obj: (string | number | null)[] = [];
          obj.push(index + 1);

          HistorianHeader.forEach((header: any) => {
            let val = row[header.key] ?? "";

            if (header.key === "caseid" && typeof val === "string") {
              val = val.slice(-3);
            }

            obj.push(val);
          });

          return obj;
        },
      );

      // ---------- PDF ----------
      const doc = new jsPDF("landscape", "mm", "a4");
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 10;

      autoTable(doc, {
        head: [headers],
        body: tableData,
        margin: { top: 28, left: 2 },
        styles: { fontSize: 9, cellPadding: 2, overflow: "linebreak" },
        tableWidth: pageWidth - margin,
        didDrawPage: (data) => {
          // ===== HEADER =====
          doc.setFontSize(12);
          doc.text("Medical Legal Portal", 2, 14);
          doc.addImage(logoBase64, "PNG", pageWidth - margin - 28, 5, 34, 12);

          // ===== TITLE =====
          doc.setFontSize(12);
          doc.text(title, 2, 22);

          // ===== FOOTER =====
          const footerY = pageHeight - 10;
          const now = new Date();
          const formattedDate = now.toLocaleString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          });

          const firstName = localStorage.getItem("firstname") ?? "";
          const lastName = localStorage.getItem("lastname") ?? "";

          const generatedByText = `Generated By & On - ${firstName} ${lastName} ${formattedDate}`;
          const pageNumberText = `Page No. ${
            data.pageNumber
          } of ${doc.getNumberOfPages()}`;

          doc.setDrawColor(0);
          doc.setLineWidth(0.1);
          doc.line(1, footerY - 5, pageWidth - 1, footerY - 5);

          doc.setFontSize(8);
          doc.text(generatedByText, 1, footerY);
          doc.text(
            pageNumberText,
            pageWidth - doc.getTextWidth(pageNumberText) - 1,
            footerY,
          );
        },
      });

      const safeFileName = title.replace(/[\/\\:*?"<>|]/g, "-");
      doc.save(`${safeFileName}.pdf`);
    } catch (error) {
      console.error("PDF Export Error:", error);
    }
  };
  const handleExportExcel = async () => {
    try {
      const sheetName = "RORData";
      const selectedStatus = activeListName;
      const [startDate, endDate] = dateRange;

      // ---------- Date Label ----------
      const formatDate = (date: Date) =>
        date.toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        });

      let dateLabel = "";
      if (startDate && endDate && startDate.getTime() !== endDate.getTime()) {
        dateLabel = `${formatDate(startDate)} to ${formatDate(endDate)}`;
      } else {
        dateLabel = formatDate(startDate || new Date());
      }

      const title = `Appointments for ${selectedStatus} ${dateLabel}`;

      // ---------- Headers ----------
      const headers: string[] = [
        "Sr. No",
        ...HistorianHeader.map((h: any) => h.label || h.name),
      ];

      // ---------- API ----------
      const trimmedQuery = searchQuery?.trim();
      const payload = {
        searchString: trimmedQuery,
        startDate: startDate ? toLocalISOString(startDate) : "",
        endDate: endDate ? toLocalISOString(endDate) : "",
        actionTrigger: activeFilter,
        pageNo: 1,
        pageSize: 100000,
        sortColumn: "",
        sortOrder: "DESC",
      };

      const response = await getHistorianSimpleSearch(payload);

      if (!Array.isArray(response) || response.length === 0) {
        alert("No data available for export");
        return;
      }

      // ---------- Prepare Excel Data ----------
      const exportData: (string | number | null)[][] = response.map(
        (row: any, index: number) => {
          const rowArr: (string | number | null)[] = [];
          rowArr.push(index + 1);

          HistorianHeader.forEach((header: any) => {
            let val = row[header.key] ?? "";

            if (header.key === "caseid" && typeof val === "string") {
              val = val.slice(-3);
            }

            rowArr.push(val);
          });

          return rowArr;
        },
      );

      // ---------- Excel ----------
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet(sheetName);

      // Title
      worksheet.mergeCells(1, 1, 1, headers.length);
      const titleCell = worksheet.getCell(1, 1);
      titleCell.value = title;
      titleCell.font = { bold: true, size: 14 };
      titleCell.alignment = { horizontal: "left" };

      // Header Row
      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };

      // Data Rows
      exportData.forEach((rowArr) => {
        worksheet.addRow(rowArr);
      });

      // Column Width
      worksheet.columns.forEach((col, index) => {
        if (col) col.width = index === 0 ? 10 : 25;
      });

      // ---------- Download ----------
      const buffer = await workbook.xlsx.writeBuffer();
      const safeFileName = title.replace(/[\/\\:*?"<>|]/g, "-");

      saveAs(
        new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        `${safeFileName}.xlsx`,
      );
    } catch (error) {
      console.error("Excel Export Error:", error);
    }
  };

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber);
    getSearchHistorianData(
      searchQuery,
      activeFilter,
      pageNumber,
      itemsPerPage,
      sortColumn,
      sortOrder,
    );
  };

  const handleSortAction = (row: any) => {
    setSortColumn(row.key);
    setSortOrder(row.direction);
    getSearchHistorianData(
      searchQuery,
      activeFilter,
      currentPage,
      itemsPerPage,
      row.key,
      row.direction,
    );
  };

  const handleRowsPerPageChange = (value: number) => {
    setItemsPerPage(value);
    setCurrentPage(1);
  };

  // Calculate text for the range of entries currently visible
  const entriesText = !totalRows
    ? "Showing 0 of 0 entries"
    : `Showing ${(currentPage - 1) * itemsPerPage + 1} to ${Math.min(
        currentPage * itemsPerPage,
        totalRows,
      )} of ${totalRows} entries`;

  // 👉 Get current week's Sunday–Saturday range
  const getCurrentWeekRange = () => {
    const today = new Date();
    const day = today.getDay(); // 0 = Sunday, 6 = Saturday

    const sunday = new Date(today);
    sunday.setDate(today.getDate() - day);

    const saturday = new Date(sunday);
    saturday.setDate(sunday.getDate() + 6);

    return [sunday, saturday] as [Date, Date];
  };

  // 👉 Get current month's 1st – last date
  const getCurrentMonthRange = () => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    return [firstDay, lastDay] as [Date, Date];
  };

  const handleCardClick = (filter: string) => {
    const current = 1;
    const perPage = 15;

    setActiveFilter(filter);
    setCurrentPage(current);
    setItemsPerPage(perPage);
    setSortColumn("");
    setSortOrder("DESC");
  };

  const handleResetDate = () => {
    if (activeListName == "Scheduled List (This Week)") {
      const [start, end] = getCurrentWeekRange();
      setDateRange([start, end]);
    } else {
      const [start, end] = getCurrentMonthRange();
      setDateRange([start, end]);
    }
  };

  const animatedPendingOverdue = useAnimatedCounter(pendingOverdueCount);
  const animatedTodayOverdue = useAnimatedCounter(todayOverdueCount);
  const animatedOverdue = useAnimatedCounter(overdueCount);

  const animatedDraftHistories = useAnimatedCounter(draftHistories);

   const animatedToday = useAnimatedCounter(scheduledToday);
  const animatedScheduledWeek = useAnimatedCounter(scheduledThisWeek);
  const animatedScheduledMonth = useAnimatedCounter(scheduledThisMonth);

  const animatedTotalPending = useAnimatedCounter(totalHistoriesPending);
  const animatedTotalCompleted = useAnimatedCounter(totalHistoriesCompleted);
  const animatedTotalCancelled = useAnimatedCounter(totalAppointmentCancelled);

  const animatedNotScheduled = useAnimatedCounter(notScheduled);
  const animatedNotScheduledOverdue = useAnimatedCounter(notScheduledOverdue);

  const animatedAwaitingResponse = useAnimatedCounter(awaitingResponse);

  const animatedAllReports = useAnimatedCounter(allReportsResponse);

  const dispatch = useDispatch();

  const [visibleHeaderIndex, setVisibleHeaderIndex] = useState<boolean>(false);

  const navigate = useNavigate();
  const location = useLocation();

  const handleCaseClick = (row: any) => {
    dispatch(setIsDashboard(true));
    dispatch(setNewCaseInFoID(row.caseInfoId));
    setVisibleHeaderIndex(true);
    sessionStorage.setItem("fromMyTodos", "true");
    navigate("/search-case", {
      state: {
        from: "mytodos",
        myTodosState: {
          searchQuery,
          dateRange,
          activeFilter,
          activeCard,
          activeSubCard,
          activeListName,
          currentPage,
          itemsPerPage,
          sortColumn,
          sortOrder,
        },
      },
    });
  };

  const resetToDefault = () => {
    setSearchQuery("");
    setDateRange([firstDayOfMonth, lastDayOfMonth]);
    setActiveFilter(HISTORIAN_SUMMARY_CODES.TOTAL_PENDING);
      setActiveCard("Histories");
                        setActiveSubCard("TP");
                        setActiveListName("Histories List (Pending)");
    // setActiveCard("Overdue");
    // setActiveSubCard("Today");
    // setActiveListName("Overdue List (Today)");
    setCurrentPage(1);
    setItemsPerPage(15);
    setSortColumn("");
    setSortOrder("DESC");
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  const hasInitialized = useRef(false);

  useEffect(() => {
    if (hasInitialized.current) return;
    hasInitialized.current = true;

    const cameFromMyTodos = sessionStorage.getItem("fromMyTodos");

    if (cameFromMyTodos === "true" && location.state?.from === "mytodos") {
      const s = location.state.myTodosState;

      setSearchQuery(s.searchQuery);
      setDateRange(s.dateRange);
      setActiveFilter(s.activeFilter);
      setActiveCard(s.activeCard);
      setActiveSubCard(s.activeSubCard);
      setActiveListName(s.activeListName);
      setCurrentPage(s.currentPage);
      setItemsPerPage(s.itemsPerPage);
      setSortColumn(s.sortColumn);
      setSortOrder(s.sortOrder);

      if (inputRef.current) {
        inputRef.current.value = s.searchQuery || "";
        getHistorianSummaryData(s.searchQuery, activeFilter);
      }

      sessionStorage.removeItem("fromMyTodos");
    } else {
      resetToDefault();
    }
  }, []);

  return (
    <>
      {/* <div className="breadcrumbg pb-0">
        <Container fluid className="px-5">
          <Stack direction="horizontal" gap={2}>
            <Row className="pt-0 fade-in-left">
              <Col>
                <h4>LIST OF PENDING HISTORIES</h4>
              </Col>
            </Row>
          </Stack>
        </Container>
      </div> */}
      <div className="main_wrapper_section appoinment_wrapper mt-3">
        <Snackbar
          open={snackbarOpen}
          message={snackbarMessage}
          onClose={() => setSnackbarOpen(false)}
          severity={error}
        />
        <Loader isLoading={loading} />

        <Container fluid className="px-5">
          <Row className="g-3">
            {" "}
            {/* g-3 adds equal gaps between cards */}
            {/* Card 1 */}
            <Col md={2}>
              <Card
                className={`h-100 todocard1 ${
                  activeCard == "Overdue" ? "active" : ""
                }`}
                style={{
                  backgroundColor: "#ffeae9",
                  borderRadius: "5px",
                  border: "1px solid #FEA1A1",
                }}
                onClick={() => {
                  setActiveCard("Overdue");
                  setActiveListName("Overdue List (Today)");
                  handleCardClick(HISTORIAN_SUMMARY_CODES.OVERDUE_TODAY);
                  setActiveSubCard("Today");
                }}
              >
                <Card.Body className="d-flex flex-column justify-content-between p-1">
                  {/* Header Row */}
                  <div className="d-flex justify-content-between align-items-center ">
                    <Card.Title
                      style={{
                        color: "#FF6D6D",
                        fontSize: "14px",
                        fontWeight: "600",
                        marginBottom: "0px",
                      }}
                    >
                      Overdue
                    </Card.Title>
                    <span
                      className="material-symbols-outlined"
                      style={{ color: "#fe6767" }}
                    >
                      timer
                    </span>
                  </div>

                  {/* Two-line details */}
                  <div className="d-flex justify-content-start">
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCardClick(
                          HISTORIAN_SUMMARY_CODES.OVERDUE_NEARDUE,
                        );
                        setActiveSubCard("Near");
                        setActiveCard("Overdue");
                        setActiveListName("Overdue List (Near Due)");
                      }}
                      style={{
                        borderRight: "1px solid transparent",
                        background:
                          "linear-gradient(to bottom, transparent 10%, #E5B7B7 10%, #E5B7B7 90%, transparent 90%) right / 1px 100% no-repeat",
                      }}
                      className={`px-1 borderRight sub-section-1 ${
                        activeSubCard == "Near" ? "active" : ""
                      }`}
                    >
                      <div style={{ fontSize: "11px", color: "#000" }}>
                        Near Due
                      </div>
                      <div
                        style={{
                          fontSize: "15px",
                          color: "#fe6767",
                          fontWeight: "600",
                        }}
                      >
                        {animatedPendingOverdue}
                      </div>
                    </div>
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCardClick(HISTORIAN_SUMMARY_CODES.OVERDUE_TODAY);
                        setActiveSubCard("Today");
                        setActiveCard("Overdue");
                        setActiveListName("Overdue List (Today)");
                      }}
                      style={{
                        borderRight: "1px solid transparent",
                        background:
                          "linear-gradient(to bottom, transparent 10%, #E5B7B7 10%, #E5B7B7 90%, transparent 90%) right / 1px 100% no-repeat",
                      }}
                      className={`px-1 borderRight sub-section-1 ${
                        activeSubCard == "Today" ? "active" : ""
                      }`}
                    >
                      <div style={{ fontSize: "11px", color: "#000" }}>
                        Today
                      </div>
                      <div
                        style={{
                          fontSize: "15px",
                          color: "#fe6767",
                          fontWeight: "600",
                        }}
                      >
                        {animatedTodayOverdue}
                      </div>
                    </div>
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCardClick(HISTORIAN_SUMMARY_CODES.OVERDUE);
                        setActiveSubCard("OVDU");
                        setActiveCard("Overdue");
                        setActiveListName("Overdue List (Past Overdue)");
                      }}
                      style={{}}
                      className={`px-1 sub-section-1 ${
                        activeSubCard == "OVDU" ? "active" : ""
                      }`}
                    >
                      <div style={{ fontSize: "11px", color: "#000" }}>
                        Overdue
                      </div>
                      <div
                        style={{
                          fontSize: "15px",
                          color: "#fe6767",
                          fontWeight: "600",
                        }}
                      >
                        {animatedOverdue}
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            {/* Card 2 */}
            <Col md={2}>
              <Card
                className={`h-100 todocard2 ${
                  activeCard == "Histories" ? "active" : ""
                }`}
                style={{
                  backgroundColor: "#FCECBE",
                  borderRadius: "5px",

                  border: "1px solid #E6C872",
                }}
                onClick={() => {
                  handleCardClick(HISTORIAN_SUMMARY_CODES.DRAFT_HISTORIES);
                  setActiveCard("Histories");
                  setActiveListName("Histories List");
                  setActiveSubCard("");
                }}
              >
                <Card.Body className="d-flex flex-column justify-content-between p-1">
                  <div className="d-flex justify-content-between align-items-center ">
                    <Card.Title
                      style={{
                        color: "#9C6F16",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      Histories
                    </Card.Title>
                    <span
                      className="material-symbols-outlined"
                      style={{ color: "#9b6d15" }}
                    >
                      draft
                    </span>
                  </div>
                   <div className="d-flex justify-content-start">
                    <div
                      onClick={(e) => {
                        e.stopPropagation(); // prevent card click
                        const [start, end] = getCurrentMonthRange();
                        setDateRange([start, end]);
                        handleCardClick(
                          HISTORIAN_SUMMARY_CODES.TOTAL_PENDING,
                        );
                        setActiveCard("Histories");
                        setActiveSubCard("TP");
                        setActiveListName("Histories List (Pending)");
                      }}
                      className={`px-1 ${
                        activeSubCard == "TP" ? "active" : ""
                      }`}
                      style={{
                        borderRight: "1px solid transparent",
                        padding: "0px 10px 0px 0px",
                        background:
                          "linear-gradient(to bottom, transparent 10%, #9b6d15 10%, #9b6d15 90%, transparent 90%) right / 1px 100% no-repeat",
                      }}
                    >
                      <div style={{ fontSize: "11px", color: "#9b6d15" }}>
                        Pending
                      </div>
                      <div
                        style={{
                          fontSize: "15px",
                         color: "#9b6d15",
                          fontWeight: "600",
                        }}
                      >
                        {animatedTotalPending}
                      </div>
                    </div>
                    <div
                      onClick={(e) => {
                        e.stopPropagation(); // prevent card click
                        const [start, end] = getCurrentMonthRange();
                        setDateRange([start, end]);
                        handleCardClick(
                          HISTORIAN_SUMMARY_CODES.DRAFT_HISTORIES,
                        );
                        setActiveCard("Histories");
                        setActiveSubCard("DR");
                        setActiveListName("Histories List (Draft)");
                      }}
                      style={{
                        padding: "0px 10px 0px 10px",
                      }}
                      className={`px-1 ${
                        activeSubCard == "DR" ? "active" : ""
                      }`}
                    >
                      <div style={{ fontSize: "11px", color: "#9b6d15" }}>
                        Draft
                      </div>
                      <div
                        style={{
                          fontSize: "15px",
                          color: "#9b6d15",
                          fontWeight: "600",
                        }}
                      >
                        {animatedDraftHistories}
                      </div>
                    </div>
                  </div>
                  {/* <div
                    style={{
                      color: "#9b6d15",
                      fontSize: "1.1rem",
                      fontWeight: "600",
                    }}
                  >
                    {animatedDraftHistories}
                  </div> */}

                </Card.Body>
              </Card>
            </Col>



            <Col md={2}>
              <Card
                className={`h-100 todocard3 ${
                  activeCard === "Scheduled" ? "active" : ""
                }`}
                style={{
                  backgroundColor: "#D6F2FF",
                  borderRadius: "5px",
                  border: "1px solid #99CEE8",
                }}
                onClick={() => {
                  const [start, end] = getCurrentWeekRange();
                  setDateRange([start, end]);
                  setActiveCard("Scheduled");
                  handleCardClick(HISTORIAN_SUMMARY_CODES.SCHEDULED_THIS_WEEK);
                  setActiveSubCard("STW");
                  setActiveListName("Scheduled List (This Week)");
                }}
              >
                <Card.Body className="d-flex flex-column justify-content-between p-1">
                  {/* Header Row */}
                  <div className="d-flex justify-content-between align-items-center ">
                    <Card.Title
                      style={{
                        color: "#0086ce",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      Scheduled
                    </Card.Title>
                    <span
                      className="material-symbols-outlined"
                      style={{ color: "#0086ce" }}
                    >
                      early_on
                    </span>
                  </div>

                  {/* Two-line details */}
                  <div className="d-flex justify-content-start">
                     <div
                      onClick={(e) => {
                        e.stopPropagation(); // prevent card click
                        const [start, end] = getCurrentWeekRange();
                        setDateRange([start, end]);
                        handleCardClick(
                          HISTORIAN_SUMMARY_CODES.SCHEDULED_TODAY,
                        );
                        setActiveCard("Scheduled");
                        setActiveSubCard("TD");
                        setActiveListName("Scheduled List (Today)");
                      }}
                      className={`px-1 ${
                        activeSubCard == "TD" ? "active" : ""
                      }`}
                      style={{
                        borderRight: "1px solid transparent",
                        padding: "0px 10px 0px 0px",
                        background:
                          "linear-gradient(to bottom, transparent 10%, #B6DDEF 10%, #B6DDEF 90%, transparent 90%) right / 1px 100% no-repeat",
                      }}
                    >
                      <div style={{ fontSize: "11px", color: "#0086ce" }}>
                        Today
                      </div>
                      <div
                        style={{
                          fontSize: "15px",
                          color: "#0086ce",
                          fontWeight: "600",
                        }}
                      >
                        {animatedToday}
                      </div>
                    </div>
                    <div
                      onClick={(e) => {
                        e.stopPropagation(); // prevent card click
                        const [start, end] = getCurrentWeekRange();
                        setDateRange([start, end]);
                        handleCardClick(
                          HISTORIAN_SUMMARY_CODES.SCHEDULED_THIS_WEEK,
                        );
                        setActiveCard("Scheduled");
                        setActiveSubCard("STW");
                        setActiveListName("Scheduled List (This Week)");
                      }}
                      className={`px-1 ${
                        activeSubCard == "STW" ? "active" : ""
                      }`}
                      style={{
                        borderRight: "1px solid transparent",
                        padding: "0px 10px 0px 0px",
                        background:
                          "linear-gradient(to bottom, transparent 10%, #B6DDEF 10%, #B6DDEF 90%, transparent 90%) right / 1px 100% no-repeat",
                      }}
                    >
                      <div style={{ fontSize: "11px", color: "#0086ce" }}>
                        This Week
                      </div>
                      <div
                        style={{
                          fontSize: "15px",
                          color: "#0086ce",
                          fontWeight: "600",
                        }}
                      >
                        {animatedScheduledWeek}
                      </div>
                    </div>
                    <div
                      onClick={(e) => {
                        e.stopPropagation(); // prevent card click
                        const [start, end] = getCurrentMonthRange();
                        setDateRange([start, end]);
                        handleCardClick(
                          HISTORIAN_SUMMARY_CODES.SCHEDULED_THIS_MONTH,
                        );
                        setActiveCard("Scheduled");
                        setActiveSubCard("STM");
                        setActiveListName("Scheduled List (This Month)");
                      }}
                      style={{
                        padding: "0px 10px 0px 10px",
                      }}
                      className={`px-1 ${
                        activeSubCard == "STM" ? "active" : ""
                      }`}
                    >
                      <div style={{ fontSize: "11px", color: "#0086ce" }}>
                        This Month
                      </div>
                      <div
                        style={{
                          fontSize: "15px",
                          color: "#0086ce",
                          fontWeight: "600",
                        }}
                      >
                        {animatedScheduledMonth}
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={2}>
              <Card
                className={`h-100 todocard4 ${
                  activeCard === "Total Histories" ? "active" : ""
                }`}
                style={{
                  backgroundColor: "#E9E5FE",
                  borderRadius: "5px",
                  border: "1px solid #9C8CEE",
                }}
                onClick={() => {
                  setActiveCard("Total Histories");
                  handleCardClick(HISTORIAN_SUMMARY_CODES.TOTAL_PENDING);
                  setActiveSubCard("TP");
                  setActiveListName("Total Histories List (Pending)");
                }}
              >
                <Card.Body className="d-flex flex-column justify-content-between p-1">
                  {/* Header Row */}
                  <div className="d-flex justify-content-between align-items-center ">
                    <Card.Title
                      style={{
                        color: "#684fe5",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      Total Histories
                    </Card.Title>
                    <span
                      className="material-symbols-outlined"
                      style={{ color: "#684fe5" }}
                    >
                      today
                    </span>
                  </div>

                  {/* Two-line details */}
                  <div className="d-flex justify-content-start">
                    {/* <div
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCardClick(HISTORIAN_SUMMARY_CODES.TOTAL_PENDING);
                        setActiveCard("Total Histories");
                        setActiveSubCard("TP");
                        setActiveListName("Total Histories List (Pending)");
                      }}
                      style={{
                        borderRight: "1px solid transparent",
                        padding: "0px 3px 0px 0px",
                        background:
                          "linear-gradient(to bottom, transparent 10%, #C3BAF2 10%, #C3BAF2 90%, transparent 90%) right / 1px 100% no-repeat",
                      }}
                      className={`px-1 ${
                        activeSubCard == "TP" ? "active" : ""
                      }`}
                    >
                      <div style={{ fontSize: "11px", color: "#684fe5" }}>
                        Pending
                      </div>
                      <div
                        style={{
                          fontSize: "15px",
                          color: "#684fe5",
                          fontWeight: "600",
                        }}
                      >
                        {animatedTotalPending}
                      </div>
                    </div> */}
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCardClick(
                          HISTORIAN_SUMMARY_CODES.TOTAL_COMPLETED,
                        );
                        setActiveCard("Total Histories");
                        setActiveSubCard("TC");
                        setActiveListName("Total Histories List (Completed)");
                      }}
                      style={{
                        borderRight: "1px solid transparent",
                        padding: "0px 3px 0px 0px",
                        background:
                          "linear-gradient(to bottom, transparent 10%, #C3BAF2 10%, #C3BAF2 90%, transparent 90%) right / 1px 100% no-repeat",
                      }}
                      className={`px-1 ${
                        activeSubCard == "TC" ? "active" : ""
                      }`}
                    >
                      <div style={{ fontSize: "11px", color: "#684fe5" }}>
                        Completed
                      </div>
                      <div
                        style={{
                          fontSize: "15px",
                          color: "#684fe5",
                          fontWeight: "600",
                        }}
                      >
                        {animatedTotalCompleted}
                      </div>
                    </div>
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCardClick(
                          HISTORIAN_SUMMARY_CODES.APPOINTMENT_CANCELLED,
                        );
                        setActiveCard("Total Histories");
                        setActiveSubCard("TCN");
                        setActiveListName("Total Histories List (Canceled)");
                      }}
                      style={{
                        padding: "0px 3px 0px 3px",
                      }}
                      className={`${activeSubCard == "TCN" ? "active" : ""}`}
                    >
                      <div style={{ fontSize: "11px", color: "#684fe5" }}>
                        Canceled
                      </div>
                      <div
                        style={{
                          fontSize: "15px",
                          color: "#684fe5",
                          fontWeight: "600",
                        }}
                      >
                        {animatedTotalCancelled}
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            {/* Add more cards similarly */}
            {/* <Col md={2}>
              <Card
                className={`todocard5 h-100 ${
                  activeCard === "Not Scheduled" ? "active" : ""
                }`}
                style={{
                  backgroundColor: "#e4eff1",
                  borderRadius: "5px",

                  border: "1px solid #33919f",
                }}
                onClick={() => {
                  handleCardClick(HISTORIAN_SUMMARY_CODES.NOT_SCHEDULED);
                  setActiveCard("Not Scheduled");
                  setActiveSubCard("NS");
                  setActiveListName("Not Scheduled List (Total)");
                }}
              >
                <Card.Body className="d-flex flex-column justify-content-between p-1">
                  <div className="d-flex justify-content-between align-items-center ">
                    <Card.Title
                      style={{
                        color: "#33919f",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      Not Scheduled
                    </Card.Title>
                    <span
                      className="material-symbols-outlined"
                      style={{ color: "#33919f" }}
                    >
                      history_toggle_off
                    </span>
                  </div>
                  <div className="d-flex justify-content-start forTwoSection">
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCardClick(HISTORIAN_SUMMARY_CODES.NOT_SCHEDULED);
                        setActiveCard("Not Scheduled");
                        setActiveSubCard("NS");
                        setActiveListName("Not Scheduled List (Total)");
                      }}
                      style={{
                        borderRight: "1px solid transparent",
                        padding: "0px 10px 0px 0px",
                        background:
                          "linear-gradient(to bottom, transparent 10%, #33919f 10%, #33919f 90%, transparent 90%) right / 1px 100% no-repeat",
                      }}
                      className={`px-1 ${
                        activeSubCard == "NS" ? "active" : ""
                      }`}
                    >
                      <div style={{ fontSize: "11px", color: "#33919f" }}>
                        Total
                      </div>
                      <div
                        style={{
                          fontSize: "15px",
                          color: "#33919f",
                          fontWeight: "600",
                        }}
                      >
                        {animatedNotScheduled}
                      </div>
                    </div>
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCardClick(
                          HISTORIAN_SUMMARY_CODES.NOT_SCHEDULED_OVERDUE,
                        );
                        setActiveCard("Not Scheduled");
                        setActiveSubCard("NSO");
                        setActiveListName("Not Scheduled List (Overdue)");
                      }}
                      style={{
                        padding: "0px 10px 0px 10px",
                      }}
                      className={`px-1 ${
                        activeSubCard == "NSO" ? "active" : ""
                      }`}
                    >
                      <div style={{ fontSize: "11px", color: "#33919f" }}>
                        Overdue
                      </div>
                      <div
                        style={{
                          fontSize: "15px",
                          color: "#33919f",
                          fontWeight: "600",
                        }}
                      >
                        {animatedNotScheduledOverdue}
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col> */}
            <Col md={2}>
              <Card
                className={`h-100 todocard6 ${
                  activeCard === "Awaiting Response" ? "active" : ""
                }`}
                style={{
                  backgroundColor: "#eee5d4",
                  borderRadius: "5px",

                  border: "1px solid #7c7c7c",
                }}
                onClick={() => {
                  handleCardClick(HISTORIAN_SUMMARY_CODES.AWAITING_RESPONSE);
                  setActiveCard("Awaiting Response");
                  setActiveSubCard("");
                  setActiveListName("Awaiting Response List");
                }}
              >
                <Card.Body className="d-flex flex-column justify-content-between p-1">
                  <div className="d-flex justify-content-between align-items-center ">
                    <Card.Title
                      style={{
                        color: "#7c7c7c",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      Awaiting Response
                    </Card.Title>
                    <span
                      className="material-symbols-outlined"
                      style={{ color: "#7c7c7c" }}
                    >
                      hourglass
                    </span>
                  </div>
                  <div
                    style={{
                      color: "#7c7c7c",
                      fontSize: "1.1rem",
                      fontWeight: "600",
                    }}
                  >
                    {animatedAwaitingResponse}
                  </div>
                </Card.Body>
              </Card>
            </Col>
               <Col md={2}>
                            <Card
                              className={`h-100 todocard5 ${
                                activeCard === "All Reports" ? "active" : ""
                              }`}
                              style={{
                                backgroundColor: "#e4eff1",
                                borderRadius: "5px",
                                cursor: "pointer",
                                border: "1px solid #33919f",
                              }}
                              onClick={() => {
                                setActiveCard("All Reports");
                                setActiveListName("All Reports List");
                                setActiveSubCard("");
                                handleCardClick(HISTORIAN_SUMMARY_CODES.ALL_REPORTS);
                              }}
                            >
                              <Card.Body className="d-flex flex-column justify-content-between p-1">
                                <div className="d-flex justify-content-between align-items-center ">
                                  <Card.Title
                                    style={{
                                      color: "#33919f",
                                      fontSize: "14px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    All Reports
                                  </Card.Title>
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "#33919f" }}
                                  >
                                    history_toggle_off
                                  </span>
                                </div>
                                <div
                                  style={{
                                    color: "#33919f",
                                    fontSize: "1.1rem",
                                    fontWeight: "600",
                                  }}
                                >
                                  {animatedAllReports}
                                </div>
                              </Card.Body>
                            </Card>
                          </Col>
          </Row>
          <div
            className="my-3"
            style={{ background: "#0092D5", height: "2px" }}
          ></div>
          <div className="container-fluid px-2">
            <div className="mt-3 mb-3">
              <Row className="align-items-center justify-content-between mb-3">
                {/* Left side: Title */}
                <Col xs="auto" className="sectionTitle noborder pe-3">
                  {activeListName}
                </Col>

                {/* Right side: Controls */}
                <Col xs="auto">
                  <div className="d-flex align-items-center gap-2">
                    {/* Date Picker */}
                    <div
                      className="date-picker-container appointment-data-range customDrodownControlDAtepicker"
                      style={{ width: "280px" }}
                    >
                      <DateRangePicker
                        label=""
                        onChange={handleDateRangeChange}
                        startDate={dateRange[0]}
                        endDate={dateRange[1]}
                        minDate={computedMinDate}
                        maxDate={computedMaxDate}
                        showResetIcon={!!dateRange[0] && !!dateRange[1]}
                        onReset={handleResetDate}
                      />
                    </div>

                    {/* Search Box */}
                    <InputGroup className="w-auto">
                      <InputGroup.Text className="px-2">
                        <span className="material-symbols-outlined text-black-50">
                          search
                        </span>
                      </InputGroup.Text>
                      <Form.Control
                        ref={inputRef}
                        aria-label="Search"
                        onChange={(e) =>
                          handleInputChange(e.target.value.trim())
                        }
                        onPaste={(e) => {
                          e.preventDefault();
                          const text = e.clipboardData.getData("text").trim();
                          handleInputChange(text);
                          if (inputRef.current) inputRef.current.value = text;
                        }}
                      />
                    </InputGroup>

                    {/* Reset Button */}
                    <Button
                      className="d-flex align-items-center"
                      style={{
                        background: "none",
                        border: "none",

                        padding: "10px",
                        fontSize: "22px",
                      }}
                      onClick={handleResetFilters}
                    >
                      <span className="material-icons reset_ic0">
                        restart_alt
                      </span>
                    </Button>

                    {/* Export Dropdown */}
                    <Dropdown as={ButtonGroup}>
                      <Dropdown.Toggle
                        variant="outline"
                        className="d-flex align-items-center btn-text-border appoinmentdropdown p-1"
                      >
                        <span className="material-symbols-outlined">
                          download
                        </span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={handleExportExcel}>
                          Export to Excel
                        </Dropdown.Item>
                        <Dropdown.Item onClick={handleExportPDF}>
                          Export to PDF
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    {/* Actions Dropdown */}
                    {selectedCaseId && (
                      <AppointmentActionsDropdown
                        name="Actions"
                        options={filteredActionOptions}
                        value={selectedAction}
                        onChange={handleActionChange}
                      />
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="mb-3 container-fluid">
            <HistorianDataTable
              headers={updatedHistorianHeader}
              rows={historionData}
              onSortAction={handleSortAction}
              radioSelection={filteredActionOptions?.length > 0}
              selectedCaseId={selectedCaseId}
              onSelectCase={(id) => setSelectedCaseId(id)}
              onInvalidSelection={(caseStage) => {
                let message = "Invalid case selection.";

                if (caseStage === CASE_STAGE_STATUS.CLOSED) {
                  message = "Case has been closed.";
                } else if (caseStage === CASE_STAGE_STATUS.CANCELLED) {
                  message = "Case has been canceled.";
                }

                setSnackbarMessage(message);
                setError("error");
                setSnackbarOpen(true);
              }}
              onCaseClick={handleCaseClick}
            />
          </div>
          <div className="d-flex justify-content-between align-items-center mt-0 mb-4 row p-0 m-0">
            {/* Display entries text on the left */}
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-6 showingData_wrapper">
                  <span>{entriesText}</span>
                </div>
                <div className="col-md-6">
                  <div className="d-flex flex-row-reverse ">
                    <CustomPagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={paginate}
                    />
                    <TableRowsPerPage
                      value={itemsPerPage}
                      onSelect={handleRowsPerPageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
      <HistorianActionDrawer
        title={drawerTitle}
        open={showHistorianActionDrawer}
        onClose={handleActionDrawer}
        placement="end"
      >
        {selectedAction == "Upload Records" && (
          <HistorianUploadRecord
            caseInfoId={selectedRowData?.caseInfoId}
            loggedInUserid={loggedInUserid}
            onCancel={handlecloseActionDrawer}
            selectedrowDataNew={selectedRowData}
          />
        )}

        {selectedAction == "Add Notes" && (
          <HistorianAddNotes
            showDrawer={showHistorianActionDrawer}
            onClose={handlecloseActionDrawer}
            caseInfoId={selectedRowData?.caseInfoId}
            caseId={selectedRowData?.caseId}
            subjectQmeScheduleID={selectedRowData?.subjectQmeScheduleID}
            isRowActionTriggered={false}
            onNotesSaved={() => {}}
            selectedRowData={selectedRowData}
            details = {selectedRowData?.patientName + " - " + selectedRowData?.caseOrExamType}
          />
        )}
      </HistorianActionDrawer>
      {selectedAction == "Schedule Date" && (
        <HistorianScheduleDate
          show={showHistorianScheduleDate}
          onHide={handlecloseScheduleDate}
          selectedRowData={selectedRowData}
        />
      )}
    </>
  );
};

export default HistorianDashboard;
